import { useEffect, useState } from 'react';
import { createArray } from '../utils/array';
import { useSession } from '../components/video/session-provider/session-provider';
const TILE_MARGIN = 8;
const TILE_HEIGHT = 162 + 2 * TILE_MARGIN;
const MOBILE_TILE_MARGIN = 4;
const MOBILE_TILE_WIDTH = 70 + 2 * MOBILE_TILE_MARGIN;
export const useFocusedLayout = (mobile, width, height, attendees, focusedAttendeeId) => {
    const [pagesCount, setPagesCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [visibleAttendeeIds, setVisibleAttendeeIds] = useState([]);
    const { sharingAttendeeId } = useSession();
    useEffect(() => {
        const count = getPagesCount(mobile, width, height, focusedAttendeeId && !sharingAttendeeId ? attendees.length - 1 : attendees.length);
        setPagesCount(count);
        if (count > 0 && currentPage > count - 1) {
            setCurrentPage(count - 1);
        }
    }, [mobile, width, height, attendees, focusedAttendeeId, sharingAttendeeId]);
    useEffect(() => {
        setVisibleAttendeeIds(getVisibleAttendeeIds(mobile, width, height, attendees, focusedAttendeeId, currentPage, sharingAttendeeId));
    }, [mobile, width, height, attendees, focusedAttendeeId, currentPage, sharingAttendeeId]);
    return {
        pagesCount,
        currentPage,
        visibleAttendeeIds,
        setCurrentPage,
    };
};
const getVisibleTilesCount = (mobile, width, height) => (mobile
    ? Math.floor((width - 2 * MOBILE_TILE_MARGIN) / MOBILE_TILE_WIDTH)
    : Math.floor((height + 2 * TILE_MARGIN) / TILE_HEIGHT)) || 1;
const getPagesCount = (mobile, width, height, attendeesCount) => Math.ceil(attendeesCount / getVisibleTilesCount(mobile, width, height));
const getVisibleAttendeeIds = (mobile, width, height, attendees, focusedAttendeeId, currentPage, sharingAttendeeId) => {
    if (!attendees.length) {
        return [];
    }
    const visibleTilesCount = getVisibleTilesCount(mobile, width, height);
    const nonFocusedAttendees = sharingAttendeeId
        ? attendees
        : attendees.filter(attendeeId => attendeeId !== focusedAttendeeId);
    return createArray(visibleTilesCount)
        .map((_, index) => index + currentPage * visibleTilesCount)
        .map(index => nonFocusedAttendees[index]);
};
//# sourceMappingURL=focused-layout.js.map